const GarageTypeSchema = {
  Id: value => typeof value === 'string',
  Height: value => parseInt(value) > 0,
  Width: value => parseInt(value) > 0
};

const validate = (object, schema) => {
  return Object.keys(schema)
    .filter(key => !schema[key](object[key]))
    .reduce((object, key) => Object.assign(object, {[key]: key}), {});
}

export const validateStepTypeGarageType = ({ choice }) => {
  if (!choice) { return null; }
  const errors = validate(choice, GarageTypeSchema);
  return {
    errors: errors,
    isValid: Object.keys(errors).length === 0
  }
}

export const validateStepTypeAutomaticDoor = ({ choice }) => {
  return { isValid: true };
}

export const validateStepTypeMontage = ({ choice }) => {
  return { isValid: true };
}

export const validateStepTypeHouseType = ({ choice }) => {
  return { isValid: true };
}

export const validateStepTypeColorsMaterials = ({ choice }) => {
  return { isValid: true };
}

export const validateStepTypeHouseStyle = ({ choice }) => {
  return { isValid: true };
}

export const validateStepTypeAreaOfUse = ({ choice }) => {
  return { isValid: true };
}
